import { render, staticRenderFns } from "./DutyTypeNew.vue?vue&type=template&id=1964df31"
import script from "./DutyTypeNew.vue?vue&type=script&lang=js"
export * from "./DutyTypeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports